import { render, staticRenderFns } from "./UserFormForceChangePassword.vue?vue&type=template&id=a1aca684&"
import script from "./UserFormForceChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserFormForceChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports